import { ChangeDetectorRef, Component, DoCheck, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { IframeEmbedService } from '../../services/iframe-embed.service';
import { NavService } from '../../services/nav-service';
import { ScreenFullService } from '../../services/screenfull-service';
import { SidePanelService } from '../../services/side-panel-service';

@Component({
  selector: 'sk-side-panel',
  styleUrls: ['./sidePanel.scss'],
  templateUrl: './sidePanel.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanelComponent implements OnInit, DoCheck, OnDestroy {

  constructor(
    public sidePanel: SidePanelService,
    public cdr: ChangeDetectorRef,
    private elementRef: ElementRef,
    private readonly iframeEmbed: IframeEmbedService,
    private readonly nav: NavService,
    private readonly screenFull: ScreenFullService
  ) {
    this.sidePanel.sidePanelChangeDetector = this.cdr;
  }

  ngDoCheck(): void {
    const padding = this.sidePanel.getPadding();
    const fallbackBg = this.iframeEmbed.isIframeEmbed ? '#f3f6f7' : 'gainsboro';
    const backgroundColor = this.sidePanel.getBackgroundColor() || fallbackBg;
    this.elementRef.nativeElement.style.setProperty('--var-padding', (padding === null || padding === undefined) ? '10px' :
      padding.toString() + 'px');
    this.elementRef.nativeElement.style.setProperty('--var-bgcolor', backgroundColor);

    /* Match sk-content top in iframe mode (embed toolbar + subheader); fullscreen: header hidden so top 0. */
    if (this.iframeEmbed.isIframeEmbed) {
      const measured = this.nav.iframeEmbedHeaderStackPx;
      const fallback = this.nav.iframeEmbedToolbarSuppressed
        ? 0
        : this.iframeEmbed.embedToolbarChromePx +
          this.nav.offsetTop -
          this.iframeEmbed.iframeMainContentTopPullUpPx;
      const raw = measured > 0 ? measured : fallback;
      const topPx = this.screenFull.isFullscreen ? 0 : Math.max(0, raw);
      this.elementRef.nativeElement.style.setProperty('top', `${topPx}px`);
      this.elementRef.nativeElement.style.setProperty('height', `calc(100% - ${topPx}px)`);
    } else {
      this.elementRef.nativeElement.style.removeProperty('top');
      this.elementRef.nativeElement.style.removeProperty('height');
    }
  }

  ngOnDestroy() {
  }

  demoSetNextStartDate() {
  }

  ngOnInit() {
  }
}
